import { Model } from "@ofqual/portal-core/core/types";

export type TransferRecord = {
  module: DialogDeciderActionTypes;
  data?: Model;
};

export enum DialogDeciderActionTypes {
  "FOI",
  null,
}
